/**
 * Как карточка возвращается к списку. Список кладёт в state свой адрес (с
 * сортировкой и фильтрами) и сколько записей истории до него: «← Заведения»
 * делает history.back на столько шагов, и ScrollManager возвращает прокрутку.
 * Без state (карточку открыли по прямой ссылке) — обычный переход на список.
 */
export interface BackState {
  backTo: string;
  backSteps: number;
  /** Подпись ссылки «←», если вернуться надо не в список заведений. */
  backLabel?: string;
}

export function readBackState(state: unknown): BackState | null {
  const s = state as Partial<BackState> | null;
  if (!s || typeof s.backTo !== 'string' || typeof s.backSteps !== 'number' || s.backSteps < 1) {
    return null;
  }
  return {
    backTo: s.backTo,
    backSteps: s.backSteps,
    ...(typeof s.backLabel === 'string' ? { backLabel: s.backLabel } : {}),
  };
}
